import { render } from "./BaseInfoTooltip.vue?vue&type=template&id=8deb14ae&scoped=true"
import script from "./BaseInfoTooltip.vue?vue&type=script&lang=js"
export * from "./BaseInfoTooltip.vue?vue&type=script&lang=js"

import "./BaseInfoTooltip.vue?vue&type=style&index=0&id=8deb14ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8deb14ae"]])

export default __exports__